/**
 * InvoiceStatusBadge Component - T151
 *
 * Displays invoice status with appropriate color coding
 */
import { statusLabels, statusColors, type InvoiceStatus } from '../../hooks/useInvoices';

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
  /** Size variant for different contexts */
  size?: 'sm' | 'md';
  className?: string;
}

export function InvoiceStatusBadge({ status, size = 'md', className = '' }: InvoiceStatusBadgeProps) {
  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-[10px]',
    md: 'px-2 py-0.5 text-xs',
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${sizeClasses[size]} ${statusColors[status]} ${className}`}
    >
      {statusLabels[status]}
    </span>
  );
}
